export default __webpack_public_path__ + "static/media/wood_cat.cca15d79.jpg";